// ServiceList.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ServiceList = ({ services, onSelectService }) => {
  const navigate = useNavigate();
  const location = useLocation();
  if (!services.length) return null; // If there are no services, don't render anything

  return (
    <div className="service-list">
      <ul>
        {services.map((service, index) => (
          <li key={index} onClick={() => navigate({
            pathname: `/service/${service.id}`,
            search: location.search
          })}>
            {service.name}
          </li>
        ))}
      </ul>
    </div>
  );
};


export default ServiceList;
